import { Order, Party, User, eOrderStatusType, eOrderType, ePartySubType, ePartyType } from "reg-hub-common";

export class Constants {
    // url parameters
    public static corporationID = "corporationID";
    public static userGroupID = "userGroupID";
    public static userID = "userID";

    public static statusComplete = "Complete";

    public static returnToOriginatingOrder = "originating";
    public static stayOnNewOrder = "new";

    public static getNormalizedPartyType(partyTypeInput: string): ePartyType | null {
        let partyType: ePartyType;
    
        if (typeof partyTypeInput === 'number') {
            partyType = partyTypeInput as ePartyType;
        } else if (typeof partyTypeInput === 'string') {
            partyType = partyTypeInput as ePartyType;
        } else {
            // Input is not a number or string, or doesn't match any enum value
            return null;
        }

        return partyType;
    }

    public static ordersHubNegotiateUrl: string = "/Hubs/Orders/Negotiate";
    public static alertsHubNegotiateUrl: string = "/Hubs/Alerts/Negotiate";
}